import request from "@/utils/request";
const baseUrl = process.env.VUE_APP_APP_API + "/member";
// 会员 集团列表
const memberApi = {
  list(params) {
    return request({
      url: `${baseUrl}/group/list`,
      method: "GET",
      params
    });
  },
  // 会员注册
  create(data) {
    return request({
      url: `${baseUrl}/register/create`,
      method: "POST",
      data
    });
  },
  // 代理机构入驻
  supplierCreate(data) {
    return request({
      url: `${baseUrl}/supplier/create`,
      method: "POST",
      data
    });
  },
  // 校验会员名称是否可以注册
  checkNameIsExist(loginName) {
    return request({
      url: `${baseUrl}/register/checkNameIsExist`,
      method: "GET",
      params: { loginName }
    });
  },
  // 获取会员协议列表
  protocolList(params) {
    return request({
      url: `${baseUrl}/protocol/list`,
      method: "GET",
      params
    });
  },
  // 获取会员协议详情
  protocolDetail(id) {
    return request({
      url: `${baseUrl}/protocol/getDetail`,
      method: "GET",
      params: { id }
    });
  }
};
export default memberApi;
